<template>
  <div class="f14 headerPage" :class='{xHeaderPage: $store.state.iphonex,notchHeaderPage: $store.state.hasNotch,wechatHeaderPage:$store.state.wechat}'>
    <Header title='请求错误' />
    <div class="tips">
      需要登录才能使用此功能！
    </div>
    <div class="button">
      <van-button type="primary" size="normal" round @click="goto">去登录/注册</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      redirct: ''
    }
  }, methods: {
    goto() {
      this.$router.replaceto({ path: '/login' })
    }
  }
}
</script>
<style lang="less" scope>
.tips {
  display: flex;
  justify-content: center;
  margin-top: 35vh;
}
.button {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/home/register/needLogin.vue